// extracted by mini-css-extract-plugin
module.exports = {"googleButton":"GoogleButton_googleButton__trtH4"};